import { Link, useSearchParams } from "react-router-dom";
import { TwitterRealtime } from "../TwitterRealtime";

export const MobileTwitterRealtime = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query") || undefined;

  return (
    <div className="flex flex-col h-full">
      <div className="p-2">
        <Link to="/mobile" className="btn btn-default">To Menu</Link>
      </div>
      <div className="flex-1 overflow-hidden">
        <TwitterRealtime query={query} />
      </div>
    </div>
  );
};
